import { Card, Row, Col, Statistic } from "antd";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import classes from "./financial.module.scss";
import { Typography } from "antd";
const { Title, Text } = Typography;

const Financial = () => {
  // Dummy KPIs
  const financialKpis = [
    { title: "Cash Flow", value: "$430,000", suffix: "" },
    { title: "Profit Margins", value: 27, suffix: "%" },
    { title: "Revenue Velocity", value: "$85,000/mo", suffix: "" },
    { title: "Financial Risk", value: "Low", suffix: "" },
  ];

  // Dummy Financial Trend Chart
  const financialTrendChart = {
    chart: { type: "line" },
    title: { text: "Financial Trend Over Time" },
    xAxis: { categories: ["Q1", "Q2", "Q3", "Q4", "Q1'", "Q2'"] },
    yAxis: { title: { text: "Revenue ($)" } },
    series: [
      {
        name: "Revenue",
        data: [200000, 250000, 300000, 350000, 400000, 430000],
      },
    ],
  };

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Financial System
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Show financial condition improvement or risk
        </Text>
      </div>
      <div style={{ padding: "20px" }}>
        {/* KPI Cards */}
        <Row gutter={[16, 16]}>
          {financialKpis.map((kpi, index) => (
            <Col span={6} key={index}>
              <Card>
                <Statistic
                  title={kpi.title}
                  value={kpi.value}
                  suffix={kpi.suffix}
                />
              </Card>
            </Col>
          ))}
        </Row>

        {/* Financial Trend Chart */}
        <Row style={{ marginTop: 30 }}>
          <Col span={24}>
            <Card title="Financial Trend">
              <HighchartsReact
                highcharts={Highcharts}
                options={financialTrendChart}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default Financial;
